export class TotalCharacterDonation {
  totalIncome: number

  writerIncome: number

  platformIncome: number
}
